const _excluded = ["isUnderReview", "focusOnInit", "editorContent", "editorInitConfig", "trackChangesEditoInitFn", "trackChangesOnCreateComment", "onEditorChange", "modelClass", "modelId", "modelField", "showTrackChangesControls"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import EditorWithChangeHighlights from './EditorWithChangeHighlights';
import { Editor } from '@tinymce/tinymce-react';
import { apiKey } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import React, { memo } from 'react';
export default /*#__PURE__*/memo(function ReviewableFieldEditor(_ref) {
  let {
      isUnderReview,
      focusOnInit = true,
      editorContent,
      editorInitConfig,
      // Accepts onCreateComment callback as an argument and calls a config function, passing the callback.
      // The config function returns the editor init config.
      trackChangesEditoInitFn,
      trackChangesOnCreateComment,
      onEditorChange,
      modelClass,
      modelId,
      modelField,
      showTrackChangesControls
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isUnderReview && /*#__PURE__*/React.createElement(EditorWithChangeHighlights, _extends({
    focusOnInit: focusOnInit,
    editorContent: editorContent,
    onEditorChange: onEditorChange,
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField,
    onCreateComment: trackChangesOnCreateComment,
    editorWithHighlightsConfig: trackChangesEditoInitFn,
    showTrackChangesControls: showTrackChangesControls
  }, props)), !isUnderReview && /*#__PURE__*/React.createElement(Editor, _extends({
    apiKey: apiKey,
    value: editorContent,
    name: "body",
    onEditorChange: onEditorChange,
    init: editorInitConfig
  }, props)));
});